import { render, staticRenderFns } from "./w-btn-volume.vue?vue&type=template&id=5a98bcfa&lang=pug&"
import script from "./w-btn-volume.vue?vue&type=script&lang=js&"
export * from "./w-btn-volume.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-volume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a98bcfa')) {
      api.createRecord('5a98bcfa', component.options)
    } else {
      api.reload('5a98bcfa', component.options)
    }
    module.hot.accept("./w-btn-volume.vue?vue&type=template&id=5a98bcfa&lang=pug&", function () {
      api.rerender('5a98bcfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-volume.vue"
export default component.exports